export function truncateFileName(fileName: string, maxLength: number): string {
  if (maxLength < 3) {
    return fileName.slice(0, Math.max(0, maxLength));
  }
  if (fileName.length <= maxLength) {
    return fileName;
  }

  const extensionIndex = fileName.lastIndexOf(".");
  const extension = extensionIndex > 0 ? fileName.substring(extensionIndex + 1) : "";
  const basenameLength = maxLength - extension.length - 3;
  if (basenameLength <= 0) {
    return `${fileName.slice(0, maxLength - 3)}...`;
  }

  return `${fileName.slice(0, basenameLength)}...${extension}`;
}
